import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CustomValidatorService } from '../../../../../../components/form-elements/custom-validator.service';
import { FormErrorsModule } from '@spartacus/storefront';
import { ToasterService } from '../../../../../../components/toaster/toaster.service';
import { isEmpty } from '../../../../../../core/services/simple-tools';
import { LoaderService } from '../../../../../../components/loader/loader.service';
import { UserAuxService } from '../../../../user/core/user-aux.service';
import { I18nModule, TranslationService } from '@spartacus/core';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'form-account-numbers',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormErrorsModule, I18nModule],
  templateUrl: './form-account-numbers.component.html',
  styleUrl: './form-account-numbers.component.scss',
})
export class FormAccountNumbersComponent implements OnInit {
  @Input() form!: FormGroup;
  @Input() accountNumbers!: string[];
  @Output() _onSetAccountNumbers = new EventEmitter<string[]>();

  constructor(
    private fb: FormBuilder,
    private customValidatorService: CustomValidatorService,
    private toasterService: ToasterService,
    private loaderService: LoaderService,
    private userAuxService: UserAuxService,
    private cdr: ChangeDetectorRef,
    private translationService: TranslationService,
  ) {}

  ngOnInit(): void {
    this.checkForm();
  }

  checkForm() {
    if (!this.form) {
      this.form = this.fb.group({
        accountNumber: ['', [this.customValidatorService.required()]],
      });
    }
  }

  setAccountNumbers(accountNumbers: string[]): void {
    this._onSetAccountNumbers.emit(accountNumbers);
  }

  removeAccountNumber(accountNumber: string): void {
    const validatedAccountNumbers = this.accountNumbers.filter(number => number !== accountNumber);
    this.setAccountNumbers(validatedAccountNumbers);
  }

  async submit() {
    this.toasterService.closeALL();
    const $accountNumber = this.form!.get('accountNumber');

    if (isEmpty($accountNumber?.value)) {
      $accountNumber?.setErrors({ required: true });
      return;
    }

    if (this.accountNumbers.includes($accountNumber?.value)) {
      const message = await firstValueFrom(
        this.translationService.translate('approvalspage.formAccountNumbers.accountNumberAlreadyInList'),
      );
      this.toasterService.displayWarning(message);
      return;
    }

    if (this.accountNumbers.length >= 10) {
      const message = await firstValueFrom(
        this.translationService.translate('approvalspage.formAccountNumbers.maxAccountNumbers'),
      );
      this.toasterService.displayWarning(message);
      return;
    }

    this.loaderService.init();

    this.userAuxService.verifyAccount($accountNumber?.value).subscribe(async response => {
      this.loaderService.init({ status: false });

      if (response.hasError) {
        this.toasterService.displayError(response.message!);
      }

      if (response.hasSuccess) {
        if (response.hasAccount) {
          const validatedAccountNumbers = this.accountNumbers;
          validatedAccountNumbers.push($accountNumber?.value);
          this.setAccountNumbers(validatedAccountNumbers);
          $accountNumber?.reset();

          const message = await firstValueFrom(
            this.translationService.translate('approvalspage.formAccountNumbers.accountNumberValidated'),
          );
          this.toasterService.displaySuccess(message);
        } else {
          this.form.get('accountNumber')?.setErrors({ invalidAccountNumber: true });
        }
      }

      this.cdr.detectChanges();
    });
  }
}
